/**
 * @generated SignedSource<<8f009773cd00112f8fb30c6ab10278c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BankTransactionDirection = "IN" | "OUT" | "%future added value";
export type BankTransactionGroup = "CUSTOMER_PAYMENTS" | "FINANCING" | "OTHER" | "SALARIES" | "SUPPLIERS" | "TAX_OFFICE" | "TRANSFER" | "%future added value";
export type BankTransactionRuleField = "COUNTERPARTY_NAME" | "PURPOSE" | "%future added value";
export type AddBankTransactionRuleInput = {
  containedText: string;
  direction?: BankTransactionDirection | null | undefined;
  field: BankTransactionRuleField;
  transactionGroup: BankTransactionGroup;
};
export type EditBankTransactionRuleDialogAddMutation$variables = {
  input: AddBankTransactionRuleInput;
};
export type EditBankTransactionRuleDialogAddMutation$data = {
  readonly addBankTransactionRule: {
    readonly id: string;
  };
};
export type EditBankTransactionRuleDialogAddMutation = {
  response: EditBankTransactionRuleDialogAddMutation$data;
  variables: EditBankTransactionRuleDialogAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BankTransactionRule",
    "kind": "LinkedField",
    "name": "addBankTransactionRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditBankTransactionRuleDialogAddMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditBankTransactionRuleDialogAddMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a9f7673ee570247296e09dc65882ce2a",
    "id": null,
    "metadata": {},
    "name": "EditBankTransactionRuleDialogAddMutation",
    "operationKind": "mutation",
    "text": "mutation EditBankTransactionRuleDialogAddMutation(\n  $input: AddBankTransactionRuleInput!\n) {\n  addBankTransactionRule(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ece18c59db6c3bcb63ba1244fd8c068b";

export default node;
